<template>
  <div class="carousel-wrapper">
    <div class="carousel-spacer" />
    <div v-if="images.length" class="img-carousel">
      <div
        v-for="(obj, index) in images"
        :key="index"
        class="img-wrapper"
      >
        <div
          v-if="(showShareModal || showWishlists) && index === 0"
          class="pdp-interaction-container"
        >
          <ShareModal
            v-if="showShareModal"
            class="mr-2"
            :shareable-text="shareableLink"
            :title="`Share ${dealName}`"
            button-class="mobile-share-icon-container"
            icon-class="dark-mode mr-1"
            wrapper-class="modal-wishlists"
            label-text="Or copy link"
            :params="socialParams"
          />
          <WishlistsButton
            v-if="showWishlists"
            :deal-id="dealId"
            :deals-count="0"
          />
        </div>
        <!-- eslint-disable vue-a11y/click-events-have-key-events -->
        <img
          class="carousel-image"
          :alt="obj.alt_text"
          height="180"
          width="320"
          :src="`${obj.image}?width=640&aspect_ratio=16:9`"
          :loading="index > 2 ? 'lazy' : 'eager'"
          :fetchpriority="index > 2 ? 'auto' : 'high'"
          @click="openModal(index)"
        >
        <!-- eslint-enable vue-a11y/click-events-have-key-events -->
      </div>

      <transition name="fade">
        <ProductsCarouselModal
          v-if="showModal"
          :slides="images"
          :thumbnails="thumbnails"
          :initial-slide="currentSlide"
          class="products-modal-container"
          @close-modal="closeModal"
        />
      </transition>
    </div>
  </div>
</template>
<script>
import WishlistsButton from '../../wishlists/Button.vue';
import ShareModal from '../../common/ShareModal.vue';
import PDPModalImgMixin from '~/mixins/pdp-modal-img';

export default {
  components: {
    ShareModal,
    WishlistsButton,
    ProductsCarouselModal: () => import('./ProductsCarouselModal.vue'),
  },
  mixins: [
    PDPModalImgMixin,
  ],
  props: {
    dealId: {
      type: Number,
      required: true,
    },
    dealName: {
      type: String,
      required: true,
    },
    images: {
      type: Array,
      default: () => [],
      required: true,
    },
    showShareModal: {
      type: Boolean,
      default: true,
    },
    showWishlists: {
      type: Boolean,
      default: true,
    },
    socialParams: {
      type: Object,
      required: true,
    },
    shareableLink: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      slideArr: this.images,
    };
  },
  head() {
    return {
      link: [
        {
          rel: 'preload',
          as: 'image',
          href: `${this.images[0].image}?width=640&aspect_ratio=16:9`,
        },
      ],
    };
  },
};
</script>

<style>
  /* Hide page scrollbars when modal is open
     an: we need it out of the scope of the component */
  .carousel-hide-scroll {
    overflow: hidden;
  }
</style>

<style lang="scss" scoped>
@import '~/styles/dorado/themes/dorado';
@import '~/styles/utils/breakpoints';

.carousel-wrapper {
  position: relative;
}

.carousel-spacer {
  height: 0;
  padding: 90px;
}

.img-carousel {
  display: flex;
  position: absolute;
  scroll-snap-type: x mandatory;
  overflow-x: scroll;
  top: 0;
  width: 96vw;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */

  /* Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  .img-wrapper {
    scroll-snap-align: start;
    margin-right: 0.5rem;
    position: relative;

    img {
      border-radius: 4px;
    }
  }

  .pdp-interaction-container {
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
    margin: 0.5rem;

    .mobile-share-icon-container {
      background-color: $gray-100;
      border-radius: 50%;
      height: 40px;
      padding: 9px 12px;
      width: 40px;
    }
  }
}

@include media-breakpoint-up(md) {
  .carousel-spacer {
    padding: 180px;
  }

  .img-wrapper {
    img {
      height: 360px;
      width: 640px;
    }
  }
}

/* Modal Transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 400ms;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
